import ArrowCircleIcon from '../assets/arrow-circle.svg?react'
import ArrowLeftIcon from '../assets/arrow-left.svg?react'
import BellIcon from '../assets/bell.svg?react'
import CameraIcon from '../assets/camera.svg?react'
import CartIcon from '../assets/cart.svg?react'
import ChangeBrandIcon from '../assets/change-brand.svg?react'
import CheckCircleOffIcon from '../assets/check-circle-off.svg?react'
import CheckCircleIcon from '../assets/check-circle.svg?react'
import CrossIcon from '../assets/close.svg?react'
import DeleteCircleIcon from '../assets/delete-circle.svg?react'
import DeleteSquareIcon from '../assets/delete-square.svg?react'
import DeleteIcon from '../assets/delete.svg?react'
import DeliveryFreeIcon from '../assets/delivery-free.svg?react'
import DeliveryIcon from '../assets/delivery.svg?react'
import ErrorIcon from '../assets/error.svg?react'
import ExpandIcon from '../assets/expand.svg?react'
import FoldIcon from '../assets/fold.svg?react'
import FreezeIcon from '../assets/freeze.svg?react'
import HintIcon from '../assets/hint.svg?react'
import LoadingIcon from '../assets/loading.svg?react'
import LogoutIcon from '../assets/logout.svg?react'
import LogoIcon from '../assets/nav-buygather-logo.svg?react'
import SearchEmptyIcon from '../assets/no-search-results.svg?react'
import OrderCancelledIcon from '../assets/order-cancelled.svg?react'
import OrderCompleteIcon from '../assets/order-complete.svg?react'
import SearchIcon from '../assets/search.svg?react'
import UnfoldIcon from '../assets/unfold.svg?react'

export const Logo = LogoIcon
export const Logout = LogoutIcon
export const Cross = CrossIcon
export const Expand = ExpandIcon
export const Search = SearchIcon
export const ChangeBrand = ChangeBrandIcon
export const CheckCircle = CheckCircleIcon
export const CheckCircleOff = CheckCircleOffIcon
export const Delete = DeleteIcon
export const Camera = CameraIcon
export const Hint = HintIcon
export const Freeze = FreezeIcon
export const Cart = CartIcon
export const DeleteCircle = DeleteCircleIcon
export const ArrowCircle = ArrowCircleIcon
export const Loading = LoadingIcon
export const DeleteSquare = DeleteSquareIcon
export const Bell = BellIcon
export const Fold = FoldIcon
export const Unfold = UnfoldIcon
export const SearchEmpty = SearchEmptyIcon
export const ErrorInfo = ErrorIcon
export const OrderCancelled = OrderCancelledIcon
export const OrderComplete = OrderCompleteIcon
export const Delivery = DeliveryIcon
export const DeliveryFree = DeliveryFreeIcon
export const ArrowLeft = ArrowLeftIcon
